import { ref } from 'vue';
import { API } from '@/services/index.js';
import { GET_ICARUS_MULTIPART_CONFIG } from '@/services/common/queries.js';

const useIcarusMultipartConfig = async () => {
  const multipartConfigSuccess = ref(false);
  const signerUrl = ref(null);
  const timeUrl = ref(null);
  const awsKey = ref(null);
  const bucket = ref(null);
  const maxConcurrentParts = ref(null);
  const maxRetryBackoffSecs = ref(null);
  const partSize = ref(null);
  const retryBackoffPower = ref(null);
  const progressIntervalMS = ref(200);
  const logging = ref(false);
  const awsSignatureVersion = ref(2);

  try {
    const res = await API.sendQuery('/graphql', GET_ICARUS_MULTIPART_CONFIG);

    if (res.data.data.icarusMultipartConfig) {
      const data = res.data.data.icarusMultipartConfig;

      multipartConfigSuccess.value = true;
      signerUrl.value = `${data.icarus_server}/sign_auth`;
      timeUrl.value = `${data.icarus_server}/sign_auth/time`;
      awsKey.value = data.aws_key;
      bucket.value = data.bucket;
      maxConcurrentParts.value = data.maxConcurrentParts;
      maxRetryBackoffSecs.value = data.maxRetryBackoffSecs;
      partSize.value = data.partSize;
      retryBackoffPower.value = data.retryBackoffPower;
    }
  } catch (e) {
    console.log(e);
    multipartConfigSuccess.value = false;
  }

  return {
    multipartConfigSuccess,
    signerUrl,
    timeUrl,
    awsKey,
    bucket,
    maxConcurrentParts,
    maxRetryBackoffSecs,
    partSize,
    retryBackoffPower,
    progressIntervalMS,
    logging,
    awsSignatureVersion
  };
};

export default useIcarusMultipartConfig;
